import { useClickOutside as useClickOutsideOriginal } from './useClickOutside.js';
export const useClickAway = (ref, callback) => {
    useClickOutsideOriginal(ref, callback);
};
//# sourceMappingURL=useClickAway.js.map